import { all, fork } from 'redux-saga/effects';

import listenAcceptCookies from './listenAcceptCookies';
import listenAppInit from './listenAppInit';
import listenHeaderNotificationDismissed from './listenHeaderNotificationDismissed';
import listenSetCurrency from './listenSetCurrency';
import listenSignIn from './listenSignIn';

export default function* appSaga() {
  yield all([
    fork(listenAcceptCookies),
    fork(listenAppInit),
    fork(listenHeaderNotificationDismissed),
    fork(listenSetCurrency),
    fork(listenSignIn),
  ]);
}
